module.exports = ".modal-header-ext {\n    background-color: #dc3545;\n}\n\n.modal-body-ext {\n    color: #12364a\n}\n"